export default __webpack_public_path__ + "static/system-30c39ba55630abcba8236c52cc5c96a5.png";